/* istanbul ignore file */
import { createAction, createReducer } from '@reduxjs/toolkit';

const dataToday = new Date();
const dataYesterday = new Date(new Date().setDate(dataToday.getDate() - 1));

const INITIAL_STATE = {
  todosFormularios: { list: [], numberPage: 1, sizePage: 10, totalRecords: 0 },
  dadosHistorico: [],
  dadosExibirDetalhar: {},
  dadosGrafico: {},
  dadosCardAtendente: {},
  protocoloReatendimento: [],
  configFiltroPesquisa: {
    filtro: {
      dataAbertura: {
        dataInicio: dataYesterday,
        dataFim: dataToday,
      },
    },
    page: 1,
    pageSize: 10,
  },
  configFiltroContribuintePesquisa: {
    filtro: {},
    page: 1,
    pageSize: 10,
  },
};
export const duckTodosFormularios = createAction('DUCK_TODOS_FORMULARIOS');
export const duckDadosHistorico = createAction('DUCK_DADOS_HISTORICO');
export const duckDadosDetalhar = createAction('DUCK_DADOS_DETALHAR_EXIBIR');
export const duckDadosGrafico = createAction('DUCK_DADOS_GRAFICO_EXIBIR');
export const duckDadosCard = createAction('DUCK_DADOS_CARD_ATENDENTE');
export const duckNovoReatendimento = createAction('DUCK_PROTOCOLOS_NOVO_REATENDIMENTO');

export const duckFiltroPesquisaRequerimento = createAction('DUCK_FILTRO_PESQUISA_REQUERIMENTO');
export const duckFiltroPesquisaRequerimentoContribuinte = createAction(
  'DUCK_FILTRO_PESQUISA_REQUERIMENTO_CONTRIBUINTE'
);

export default createReducer(INITIAL_STATE, {
  [duckTodosFormularios.type]: (state, action) => ({
    ...state,
    todosFormularios: action.payload,
  }),
  [duckDadosHistorico.type]: (state, action) => ({
    ...state,
    dadosHistorico: action.payload,
  }),
  [duckDadosDetalhar.type]: (state, action) => ({
    ...state,
    dadosExibirDetalhar: action.payload,
  }),
  [duckDadosGrafico.type]: (state, action) => ({
    ...state,
    dadosGrafico: action.payload,
  }),
  [duckDadosCard.type]: (state, action) => ({
    ...state,
    dadosCardAtendente: action.payload,
  }),
  [duckNovoReatendimento.type]: (state, action) => ({
    ...state,
    protocoloReatendimento: action.payload,
  }),
  [duckFiltroPesquisaRequerimento.type]: (state, action) => ({
    ...state,
    configFiltroPesquisa: action.payload,
  }),
  [duckFiltroPesquisaRequerimentoContribuinte.type]: (state, action) => ({
    ...state,
    configFiltroContribuintePesquisa: action.payload,
  }),
});
